<template>
  <ubi-page-container class="Broadcast">
    <template v-slot:page-actions>
      <span class="inline" v-if="selected.length != 0">{{ selected.length }} {{ $t('portals.broadcast.selectedAds', { count: selected.length }) }}</span>
      <span class="inline">&nbsp;</span>
      <el-button @click="confirmDesactivationList = true" inline type="warning">
        <span @click="eventAnalytics('desactiver_diffusion')">{{ $t('portals.broadcast.disableDiffusion') }}</span>
      </el-button>
      <el-button @click="programValidLotModal = true" inline type="primary" v-if="(isPromoteur || isBailleurSocial) && filter.annonceParente == null">
        <span @click="eventAnalytics('diffuser_annonces')">{{ $t('portals.broadcast.diffuseAds') }}</span>
      </el-button>
      <el-button @click="confirmDiffusionList = true" :disabled="!isModeSelectionAutomatiqueManuelleParAnnonceur" inline type="primary" v-else>
        <span @click="eventAnalytics('diffuser_annonces')">{{ $t('portals.broadcast.diffuseAds') }}</span>
      </el-button>
    </template>

    <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-panel>
        <el-dialog class="ValiderSelection" :title="$t('portals.list.portalSelectionActivateDiffusionTitle')" :visible.sync="programValidLotModal">
          <span>{{ $t('portals.list.portalSelectionActivateDiffusionText') }}</span><br/><br/>
          <el-checkbox v-if="isPromoteur && filter.annonceParente == null" v-model="checkLots" true-label="oui" false-label="non">
            {{ $t('portals.list.validateLotsDiffusion') }}
          </el-checkbox>
          <el-checkbox v-if="isBailleurSocial && filter.annonceParente == null" v-model="checkLots" true-label="oui" false-label="non">
            {{ $t('portals.list.validateLotsDiffusionBailleur') }}
          </el-checkbox>

          <span slot="footer" class="dialog-footer">
          <el-button @click="programValidLotModal = false">{{ $t('portals.list.cancel') }}</el-button>
          <el-button type="primary" @click="validerSelection">{{ $t('portals.list.confirm') }}</el-button>
        </span>
        </el-dialog>
        <el-dialog :title="$t('portals.broadcast.confirmSelectionDeactivationTitle')" :visible.sync="confirmDesactivationList" width="30%">
          <span class="text-left">{{ $t('portals.broadcast.confirmSelectionDeactivation') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmDesactivationList = false">{{ $t('posts.dialog.cancel') }}</el-button>
            <el-button type="primary" @click="desactiverSelection"> {{ $t("portals.broadcast.deactivated") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$t('portals.broadcast.confirmSelectionDiffusionTitle')" :visible.sync="confirmDiffusionList" width="30%">
          <span class="text-left">{{ $t('portals.broadcast.confirmSelectionDiffusion') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmDiffusionList = false">{{ $t('posts.dialog.cancel') }}</el-button>
            <el-button type="primary" @click="validerSelection"> {{ $t("portals.broadcast.broadcast") }}</el-button>
          </span>
        </el-dialog>
        <el-row :gutter="20">
          <el-col :lg="16" :md="12">
            <h1 v-if="portal != null">{{ portal.infos.diffuseurNom }}</h1>

            <el-row v-if="!isPromoteur && ( (isMainAccount || isSubAdmin) || !quotaPersonnel )">
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.quota') }}</strong>
                <p v-if="portal.infos.quotaIllimite === true">{{
                    $t('portals.broadcast.quotaUnlimited')
                  }}
                </p>
                <p v-else-if="!quotaPerUser">{{ portal.infos.nbAnnoncesQuota }}</p>
                <p v-else-if="quotaPerUser">{{ this.userQuotaPerPortal.reponse }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else>{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal != null && !isPromoteur">
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }}</strong>
                <br>
                <div
                    v-if="((portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees) < 600) && ((portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees) > 0) && portal.infos.quotaIllimite === false"
                    style="color: darkorange">
                  <span>{{ portal.infos.nbAnnoncesSelectionnees }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite && (portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees) > 0">
                    <div slot="content">
                      {{
                        $t('portals.broadcast.remainingMessageQuota', {
                          number:
                              portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees
                        })
                      }}
                    </div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                  <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite && (portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees) === 0">
                    <div slot="content">
                      {{ $t('portals.broadcast.reachedAdsLimitQuotas') }}
                    </div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <span v-else>
                <span v-if="stockPostForUser">
                    <span
                        v-if="this.nbAnnoncesSelectionneesForUser < this.userQuotaPerPortal.reponse && !portal.infos.quotaIllimite">{{
                        this.nbAnnoncesSelectionneesForUser
                      }}/<span>{{ this.totalAnnonceForUser }}</span>
                    </span>
                    <span
                        v-else-if="this.nbAnnoncesSelectionneesForUser === this.userQuotaPerPortal.reponse && !portal.infos.quotaIllimite">
                      {{this.nbAnnoncesSelectionneesForUser }}/<span>{{ this.totalAnnonceForUser }}</span>
                      <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite">
                        <div slot="content">{{ $t('portals.broadcast.reachedAdsLimitQuotas') }}</div>
                      <em class="el-icon-question"></em>
                  </el-tooltip>
                    </span>
                   <span
                       v-else-if="portal.infos.quotaIllimite">
                      {{ portal.infos.nbAnnoncesSelectionnees }}
                    </span>
                    <span v-else style="color: #d35b68">{{ this.nbAnnoncesSelectionneesForUser }}/<span>{{ this.totalAnnonceForUser }}</span>
                       <el-tooltip placement="top-start">
                          <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                          <em class="el-icon-question"></em>
                       </el-tooltip>
                    </span>
                </span>
                <span v-else>
                    <span
                        v-if="portal.infos.nbAnnoncesSelectionnees < this.userQuotaPerPortal.reponse && !portal.infos.quotaIllimite">
                      {{ portal.infos.nbAnnoncesSelectionnees }}
                    </span>
                    <span
                      v-else-if="portal.infos.nbAnnoncesSelectionnees === this.userQuotaPerPortal.reponse && !portal.infos.quotaIllimite">
                      {{ portal.infos.nbAnnoncesSelectionnees }}
                      <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite">
                        <div slot="content">{{ $t('portals.broadcast.reachedAdsLimitQuotas') }}</div>
                      <em class="el-icon-question"></em>
                  </el-tooltip>
                    </span>
                   <span
                       v-else-if="portal.infos.quotaIllimite">
                      {{ portal.infos.nbAnnoncesSelectionnees }}
                    </span>
                    <span v-else
                          style="color: #d35b68">{{ portal.infos.nbAnnoncesSelectionnees }}</span>
                     <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite">
                        <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                        <em class="el-icon-question"></em>
                    </el-tooltip>
                </span>

                </span>
                </span>
                <div
                    v-else-if="((portal.infos.nbAnnoncesQuota - portal.infos.nbAnnoncesSelectionnees) < 0) && portal.infos.quotaIllimite === false"
                    style="color: #d35b68">
                  <span>{{ portal.infos.nbAnnoncesSelectionnees }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ portal.infos.nbAnnoncesSelectionnees }}</span>
                  <span
                      v-if="portal.infos.nbAnnoncesQuota && portal.infos.nbAnnoncesQuota > 0">/{{ portal.infos.nbAnnoncesQuota }}</span>
                  <span v-else>/{{ portal.infos.nbAnnoncesMax }}</span>
                </div>
              </el-col>
            </el-row>

            <!-- Affichage quota personnel -->
            <el-row v-if="quotaPersonnel && !isPromoteur">
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.list.quotaPerso') }}</strong>
                <p v-if="portal.infos.quotaIllimite === true">
                  {{ $t('portals.broadcast.quotaUnlimited') }}
                </p>
                <p v-else>
                  {{ this.quotaForUserPorPortal }}
                </p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else>{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>

              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }}</strong>
                <br>
                <div v-if="getQuotaCurrentUser !== 'Aucun Quota' && getSelectedAdsCurrentUser < getQuotaCurrentUser">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start">
                    <div slot="content"> {{
                        $t('portals.broadcast.remainingMessageQuota', {
                          number:
                              getQuotaCurrentUser - getSelectedAdsCurrentUser
                        })
                      }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="getQuotaCurrentUser !== 'Aucun Quota'  && getQuotaCurrentUser === getSelectedAdsCurrentUser">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite">
                    <div slot="content">{{ $t('portals.broadcast.reachedAdsLimitQuotas') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>

                <div v-else :style="[portal.infos.quotaIllimite ? {color: '#000'} : {color: '#d35b68'}]">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start" v-if="!portal.infos.quotaIllimite">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
              </el-col>

            </el-row>
            <!-- Pour les promoteurs-->
            <el-row v-if="isPromoteur && (isMainAccount || isSubAdmin || !quotaPersonnel)">
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.quota') }}</strong>
                <p v-if="portal.infos.quotaIllimite === true">{{
                    $t('portals.broadcast.quotaUnlimited')
                  }}</p>
                <p v-else>{{ portal.infos.nbAnnoncesQuota }}</p>
              </el-col>
              <el-col :lg="16" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else>{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }} :</strong>
                <br>
                <div
                    v-if="(( (this.nbAnnoncesSelectionneesUser) > portal.infos.nbAnnoncesQuota)) && portal.infos.quotaIllimite === false"
                    style="color: #d35b68">
                  <span>{{ portal.infos.nbAnnoncesSelectionneesUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }} :</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ portal.infos.nbAnnoncesSelectionnees }}</span>
                  <span
                      v-if="portal.infos.nbAnnoncesQuota && portal.infos.nbAnnoncesQuota > 0">/{{ portal.infos.nbAnnoncesQuota }}</span>
                </div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaProgram') }} :</strong>
                <br/>
                <div>{{ portal.infos.nbAnnoncesSelectionneesProgrammes }} / {{ this.nbProgrammesTotal }}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaLot') }} :</strong>
                <br/>
                <div>{{ portal.infos.nbAnnoncesSelectionneesLots }} / {{ this.nbLotsTotal }}</div>
              </el-col>
              <el-col :lg="24" class="mb-3" v-if="quotaPersonnel">
                <hr>
              </el-col>
            </el-row>
            <!--                    Quota personnel promoteur -->
            <el-row v-if="quotaPersonnel && isPromoteur">
              <el-col :lg="8" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.list.quotaPerso') }}</strong>
                <p v-if="portal.infos.quotaIllimite === true">{{ $t('portals.broadcast.quotaUnlimited') }}</p>
                <p v-else>{{ this.quotaForUserPorPortal }}</p>
              </el-col>
              <el-col :lg="16" class="mb-3" v-if="portal != null">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else>{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }} :</strong>
                <br>
                <div
                    v-if="((this.nbLotsTotalUser + this.nbProgrammesTotalUser) > this.quotaForUserPorPortal) && portal.infos.quotaIllimite === false"
                    style="color: #d35b68">
                  <span>{{ this.nbLotsActifsUser + this.nbProgrammesActifsUser }} / {{ this.nbLotsTotalUser + this.nbProgrammesTotalUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }} :</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ this.nbLotsActifsUser + this.nbProgrammesActifsUser }} / {{ this.nbLotsTotalUser + this.nbProgrammesTotalUser }}</span>
                </div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaProgram') }} :</strong>
                <br/>
                <div>{{ this.nbProgrammesActifsUser }} / {{ this.nbProgrammesTotalUser }}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaLot') }} :</strong>
                <br/>
                <div>{{ this.nbLotsActifsUser }} / {{ this.nbLotsTotalUser }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="text-muted" style="text-align: center;">
              <el-image
                  :src="portal.infos._embedded.diffuseur.logo"
                  :srcset="portal.infos._embedded.diffuseur.logo"
                  v-if="portal != null"
              />
            </div>
          </el-col>
        </el-row>
      </ubi-panel>

      <el-form @submit.prevent.native="fetchList" label-position="top">
        <ubi-panel :title="$t('portals.broadcast.adsSelection')" style="background-color: #EBF3F2;">
          <p>
            {{ $t('portals.broadcast.adsSelectionText') }}
            <strong v-if="portal != null">{{ portal.infos.nom }}</strong>.
          </p>
          <hr/>
          <ubi-search-container
              v-on:resetfilter="resetSearch"
              :defaultFilter="this.filter.preset">
            <!-- Recherche sur type d'annonce pour bailleurs sociaux -->
            <el-row>
              <el-col :lg="10" v-if="nbStocks > 1">
                <el-form-item :label="$t('general.filters.stockSelection')">
                  <el-select
                      v-model="filter.stock"
                      :placeholder="$t('general.filters.stockSelectionPlaceholder')"
                      clearable
                  >
                    <el-option
                        v-for="stock in stocks"
                        :key="stock.id"
                        :label="upperCase(stock.nom)"
                        :value="stock.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="24" style="padding-left: 10px; padding-right: 10px;padding-top:10px;"
                      v-if="isBailleurSocial">
                <el-form-item :label="$t('posts.postType')" prop="typeObjet">
                  <el-radio label="ancien" v-model="filter.bailleurType" value="ancien">{{
                      $t('posts.immoAncien')
                    }}
                  </el-radio>
                  <el-radio label="program" v-model="filter.bailleurType" value="program">{{
                      $t('posts.newPrograms')
                    }}
                  </el-radio>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item :label="$t('general.filters.openSearch')">
                  <el-input v-model="filter.search" type="text"
                            :placeholder="$t('general.filters.openSearchPlaceholder')"/>
                </el-form-item>
              </el-col>
            </el-row>
          </ubi-search-container>
        </ubi-panel>
      </el-form>

      <ubi-panel :full-width="browserContext.up('lg')" v-if="portal != null">
        <ubi-list-header
            slot="header"
            :limits="limits"
            :total="results.total"
            :page.sync="page"
            :limit.sync="limit"
            :sort.sync="sort"
            :sortProperties="sortProperties"
            @input="fetchList"
        >

        </ubi-list-header>
        <template slot="selection">
          <ubi-list-selection
              v-model="selected"
              arrow-down
              :total="results.count"
              :selection="selections"
              @select="doSelect"
          />
        </template>
        <template slot="actions">
          <el-button size="mini" v-if="filter.annonceParente != null"
                     @click="retourProgramme(filter.annonceParente)">
            {{ $t('portals.broadcast.backProgram') }}
          </el-button>
        </template>

        <ubi-list-footer
            slot="footer"
            :limits="limits"
            :total="results.total"
            :page.sync="page"
            :limit.sync="limit"
            :sort.sync="sort"
            :sortProperties="sortProperties"
            @input="fetchList"
        ></ubi-list-footer>
        <el-table
            ref="table"
            :data="results.list"
            @select="selectedChanged"
            @select-all="selectAllChanged"
            v-if="browserContext.up('lg') && portal != null"
            @sort-change="trieTableau"
        >
          <el-table-column fixed type="selection" width="68" :selectable="canSelectRow" v-if="possedeSelectionPertinente"></el-table-column>
          <el-table-column fixed type="selection" width="68" v-else></el-table-column>
          <el-table-column fixed width="96" :label="$t('portals.broadcast.columnSelected')" prop="col_diff" sortable="custom">
            <template v-slot="{ row }">
              <div style="text-align: center;">
                <div v-if="possedeSelectionPertinente && row.selectionPertinente === '0'">
                  <el-tooltip placement="top-start">
                    <div slot="content" v-html="formatMessageTooltip(row.messageSelectionPertinente)"></div>
                    <em class="el-icon-question text-warning mr-2" style="font-size:1.9em;"/>
                  </el-tooltip>
                </div>
                <div v-else-if="row.estActiveDiffuseur == true"><em class="el-icon-success text-success mr-2" style="font-size:2em;" /></div>
                <div v-else>-</div>
              </div>
              <div style="font-size: 12px; margin-top: 8px;">{{ row.date_maj_selection }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnPicture')" width="150">
            <template v-slot="{ row }">
              <img
                  alt=""
                  v-if="row.photoPrincipale != null"
                  :src="row.photoPrincipale.url_miniature"
                  height="80"
              />
              <div v-else style="text-align: center;">
                <ubi-icon class="no-photo" name="camera" size="100"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dateCreation" sortable :label="$t('portals.report.columnDateCreation')" min-width="140">
            <template v-slot="{row}">
              {{ row.dateCreation.substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnReference')" prop="col_ref" width="180"
                           sortable="custom">
            <template v-slot="{ row }">
              <strong style="color: #d35b68">{{ row.reference }}</strong>
              <div class="small">{{ row.titre }}</div>
              <el-tags-posts :size="size" :typeObjet="row.typeObjet" :annonceParente="row.annonceParente"
                             v-if="isBailleurSocial">
              </el-tags-posts>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnCity')" width="200">
            <template
                v-slot="{ row }"
            >
              <div v-if="row.donnees.ville && row.donnees.code_postal">
                {{ row.donnees.ville.valeur }}({{ row.donnees.code_postal.valeur }})
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnPrice')" prop="col_price" width="120" sortable="custom" v-if="!isPromoteur || (isPromoteur && filter.annonceParente)">
            <template v-slot="{ row }">
              <div v-if="row.prix != 'Loyer : nous consulter'">{{ row.prixDisplay }}</div>
              <div v-else>{{ $t('portals.broadcast.priceContactUs') }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.nbLotsBroadcasted')" width="120" v-if="((isPromoteur || isBailleurSocial) && filter.annonceParente == null)">
            <template v-slot="{ row: result }">
              <a v-if="result.typeObjet >= 3000 && result.typeObjet < 4000">
                {{ result.nbLotsCoches }}/{{ result.nbLots }}
              </a>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Actions" align="right" width="100">
            <template v-slot="{ row }">
              <el-button v-if="(isPromoteur || isBailleurSocial) && row.typeObjet >= 3000 && row.typeObjet <= 4000 && filter.annonceParente == null" @click="setProgramme(row.id)" class="Route" size="mini">{{ $t('posts.card.seeLots') }}</el-button>
              <router-link v-else :to="{ name: 'post-view', params: { post: row.id } }" target="_blank" rel="noopener" class="Route">
                <el-button size="mini" icon="eye"></el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>

        <!-- Affichage du tableau en mode responsive -->

        <ubi-card-container :data="results.list" v-loading.fullscreen.lock="loading"
                            :element-loading-text="$t('portals.list.chargementDonnees')" v-else>
          <template v-slot="{ row: result }">
            <ubi-card v-model="selected" :label="String(result.id)">
              <template slot="header">
                <div style="text-align: center;">
                  <img
                      alt=""
                      width="50%"
                      :src="result.logo"
                      :srcset="result.logo"
                  />
                </div>
              </template>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  <h3>{{ result.titre }}</h3>
                </el-col>
                <el-col :span="null">{{ result.reference }}</el-col>
              </el-row>
              <el-row><br/></el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  {{ result.donnees.ville.valeur }}
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  {{ result.prixDisplay }}
                </el-col>
                <el-col :span="null">
                  {{ result.dateCreation }}
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between">
                <img style="margin: auto;" v-if="result.photoPrincipale != null"
                     alt=""
                     :src="result.photoPrincipale.url" height="150"/>
                <div style="margin: auto;" v-else>
                  <ubi-icon class="no-photo" name="camera" size='150'/>
                </div>
              </el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  <el-button
                      v-if="(isPromoteur || isBailleurSocial) && result.typeObjet >= 3000 && result.typeObjet <= 4000 && filter.annonceParente == null"
                      @click="setProgramme(result.id)" class="Route" size="mini">Voir les lots
                  </el-button>
                  <router-link v-else :to="{ name: 'post-view', params: { post: result.id } }"
                               target="_blank" rel="noopener" class="Route">
                    <el-button size="mini" icon="eye"></el-button>
                  </router-link>
                </el-col>
                <el-col :span="null">
                  <div v-if="possedeSelectionPertinente">
                    <em class="el-icon-success text-success mr-2" style="font-size:2em;"
                        v-if="result.estActiveDiffuseur == true"/>
                    <div v-else>
                      <el-tooltip placement="top-start" v-if="result.selectionPertinente === '0'">
                        <div slot="content"
                             v-html="formatMessageTooltip(row.messageSelectionPertinente)">
                        </div>
                        <em class="el-icon-question text-warning mr-2" style="font-size:1.9em;"/>
                      </el-tooltip>
                    </div>
                  </div>
                  <div v-else>
                    <em class="el-icon-success text-success mr-2" style="font-size:2em;"
                        v-if="result.estActiveDiffuseur == true"/>
                    <span v-else>-</span>
                  </div>
                </el-col>
              </el-row>
            </ubi-card>
          </template>
        </ubi-card-container>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>
<style>
.el-loading-spinner {
  top: 10% !important;
}
</style>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getDiffusionAnnonceurById,
  diffusionAnnonceActivate,
  getDiffusionAnnonceByAnnonceForPortal,
  getUserQuotaPerPortal
} from '@/services/portals'
import {
  getPosts,
  getNbTotalProgrammes,
  getNbTotalLots,
  getNbProgrammesActifs,
  getNbLotsActifs, getNbTotalLotsProgramme, getNbTotalLotsCochesProgramme
} from '@/services/posts'
import _uniq from 'lodash/uniq'
import TagsPosts from '../posts/components/TagsPosts'

export default {
  name: 'Broadcast',
  components: {
    ElTagsPosts: TagsPosts
  },
  inject: ['browserContext'],
  data () {
    return {
      loading: false,
      portal: null,
      portalId: this.$route.params.portal,
      limits: [10, 10 * 2, 10 * 5],
      selected: [],
      selection: null,
      selections: [],
      allPostsSelected: [],
      size: 'medium',
      sortProperties: {},
      nbProgrammesTotal: 0,
      checkLots: true,
      nbLotsTotal: 0,
      nbProgrammesActifs: 0,
      nbLotsActifs: 0,
      programValidLotModal: false,
      nbProgrammesTotalUser: 0,
      nbLotsTotalUser: 0,
      nbProgrammesActifsUser: 0,
      nbLotsActifsUser: 0,
      quotaPersonnel: false,
      annonceSelectionneeForPortail: 0,
      totalAnnoncesForUser: 0,
      quotaForUserPorPortal: '',
      userQuotaPerPortal: '',
      quotaPerUser: false,
      stockPostForUser: false,
      nbAnnoncesSelectionneesForUser: 0,
      nbAnnoncesSelectionneesProgrammes: 0,
      nbAnnoncesSelectionneesLots: 0,
      nbAnnoncesSelectionnees: 0,
      totalAnnonceForUser: 0,
      nbAnnoncesSelectionneesUser: 0,
      trieRef: null,
      triePrice: null,
      trieActive: null,
      portalCodeName: null,
      confirmDesactivationList: false,
      confirmDiffusionList: false
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes']),
    ...mapGetters('broadcast', ['getQuotaCurrentUser', 'getSelectedAdsCurrentUser']),
    ...mapState('broadcast', ['filter', 'results']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    univers () {
      return this.sitimmoUser.univers
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    possedeSelectionPertinente () {
      return this.sitimmoUser.selection_pertinente
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    page: {
      get () {
        return this.filter.page
      },
      async set (value) {
        window.scrollTo(0, 0)
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        await this.fetchList()
        this.toggleSelection()
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      async set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
        this.toggleSelection()
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
        this.toggleSelection()
      }
    },
    isModeSelectionAutomatiqueManuelleParAnnonceur () {
      return (this.portal !== null && this.portal.infos !== null) && (
        this.portal.infos.modeSelectionAutomatique === 'manuelle par l\'annonceur' ||
        this.portal.infos.modeSelectionAutomatique === 'manual por el anunciante' ||
        this.portal.infos.modeSelectionAutomatique === 'manual by the advertiser'
      )
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async mounted () {
    this.filter.annonceParente = null
    await this.updateSelectedPostCountForUserQuota()
    await this.getPortal(true)
  },
  methods: {
    ...mapMutations('broadcast', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter'
    ]),
    eventAnalytics (category) {
      this.$ga.event('selection_annonces', 'clic', category, this.sitimmoUser.id)
    },
    resetSearch () {
      this.resetFilter()
      this.fetchList()
    },
    async fetchList () {
      // No need to interrupt promises when the router changes...
      this.loading = true
      this.filter.annoncesVendues = false
      this.portalCodeName = this.portal.infos._embedded.diffuseur.nom_de_code
      if (this.portalCodeName.search('BIENS_VENDUS') >= 0) {
        this.filter.annoncesVendues = true
        this.filter.annoncesActivees = null
      }
      if (this.isPromoteur && !this.filter.annonceParente) {
        this.filter.typeObjets = 3000
      } else {
        delete (this.filter.typeObjets)
      }
      const result = await getPosts(this.filter, this.portal.infos._embedded.diffuseur.id, true, this.univers)

      if (result.type == 'error') {
        this.loading = false
        return false
      }
      // QUOTA :
      if (this.user.identifierValue != null && this.user.identifierCode != null) {
        await this.chargementDonneesQuotas(result)
      }
      // Partie promoteur
      if (this.sitimmoUser.metier === 'PROMOTEUR' || this.sitimmoUser.metier === 'BAILLEUR_SOCIAL') {
        await this.chargementPromoteur(result)
        const annonces = await this.getInfosLots(result.list)
        result.list = annonces
        this.setResults(result)
      } else {
        this.setResults(result)
      }
      await this.getPortal()
      this.loading = false
    },
    async chargementPromoteur (result) {
      this.nbProgrammesTotal = await getNbTotalProgrammes('ag' + this.sitimmoUser.id, false)
      this.nbLotsTotal = await getNbTotalLots('ag' + this.sitimmoUser.id, false)
      this.nbProgrammesActifs = await getNbProgrammesActifs('ag' + this.sitimmoUser.id, this.portal.infos._embedded.diffuseur.id, false)
      this.nbLotsActifs = await getNbLotsActifs('ag' + this.sitimmoUser.id, this.portal.infos._embedded.diffuseur.id, false)
    },
    async getProgramNbLots (parentId) {
      const portalId = this.portal.infos._embedded.diffuseur.id
      return await getNbTotalLotsProgramme(parentId, portalId)
    },
    async getProgramNbLotsCoches (parentId) {
      const portalId = this.portal.infos._embedded.diffuseur.id
      return await getNbTotalLotsCochesProgramme(parentId, portalId)
    },
    async getInfosLots (annonces) {
      const tabAnnonces = []
      annonces.forEach(async function (annonce) {
        if (annonce.id) {
          const nbLotsProgramme = await this.getProgramNbLots(annonce.id)
          annonce.nbLots = nbLotsProgramme
          const nbLotsCochesProgramme = await this.getProgramNbLotsCoches(annonce.id)
          annonce.nbLotsCoches = nbLotsCochesProgramme
        } else {
          annonce.nbLots = 0
          annonce.nbLotsCoches = 0
        }
        tabAnnonces.push(annonce)
      }, this)
      return tabAnnonces
    },
    async chargementDonneesQuotas (result) {
      const idPortail = this.portal.infos.id
      this.quotaForUserPorPortal = await getUserQuotaPerPortal(this.user.id, idPortail)
      if (this.quotaForUserPorPortal.type === 'error') {
        this.loading = false
        return false
      } else {
        this.quotaForUserPorPortal = this.quotaForUserPorPortal.reponse
      }
      this.loading = true
      this.quotaPersonnel = true
      if (this.sitimmoUser.metier !== 'PROMOTEUR') {
        this.totalAnnoncesForUser = result.list.length
        // On récupére le nombre d'annonce diffusée pour ce portail
        for (let j = 0; j < result.list.length; j++) {
          this.loading = true
          const diffusionAnnonce = await getDiffusionAnnonceByAnnonceForPortal(result.list[j].id, idPortail)
          if (diffusionAnnonce.type == 'error') {
            this.loading = false
            return false
          } else if (diffusionAnnonce.length != 0) {
            this.annonceSelectionneeForPortail++
          }
        }
      } else {
        this.loading = true
        this.quotaPersonnel = true
        this.nbProgrammesTotalUser = await getNbTotalProgrammes('ag' + this.sitimmoUser.id, true)
        this.nbLotsTotalUser = await getNbTotalLots('ag' + this.sitimmoUser.id, true)
        this.nbProgrammesActifsUser = await getNbProgrammesActifs('ag' + this.sitimmoUser.id, this.portal.infos._embedded.diffuseur.id, true)
        this.nbLotsActifsUser = await getNbLotsActifs('ag' + this.sitimmoUser.id, this.portal.infos._embedded.diffuseur.id, true)
      }
      this.loading = false
    },
    trieTableau (column) {
      if (column.prop === 'col_ref') {
        if (column.order === 'ascending') {
          this.filter.sort = 'R'
        } else if (column.order === 'descending') {
          this.filter.sort = '-R'
        } else {
          this.filter.sort = '-DC'
        }
      } else if (column.prop === 'col_price') {
        if (column.order === 'ascending') {
          this.filter.sort = 'P'
        } else if (column.order === 'descending') {
          this.filter.sort = '-P'
        } else {
          this.filter.sort = '-DC'
        }
      } else if (column.prop === 'col_diff') {
        this.filter.linkedPortals = [this.portal.infos._embedded.diffuseur.id]
        if (column.order === 'ascending') {
          this.filter.sort = 'APA'
        } else if (column.order === 'descending') {
          this.filter.sort = '-APA'
        } else {
          this.filter.linkedPortals = null
          this.filter.sort = '-DC'
        }
        this.filter.page = 1
      }
      this.fetchList()
    },
    canSelectRow (row, index) {
      if (this.portal.infos.modeSelectionAutomatique.includes('automatique')) {
        return false
      }
      if (this.possedeSelectionPertinente === true) {
        if (row.selectionPertinente !== '0') {
          return true
        } else {
          return false
        }
      }
    },
    async getPortal (mounted = null) {
      this.portal = await getDiffusionAnnonceurById(this.$route.params.portal)
      if (this.portal.type === 'error') {
        this.loading = false
        return false
      }
      if (mounted != null) {
        this.fetchList()
      }
    },
    doSelect (type) {
      switch (type) {
        case '*':
          const tmpSelection = this.results.list.map(({ id }) => id)
          this.selected = _uniq(this.selected.concat(tmpSelection))
          this.toggleSelection()
          break
        case null:
        default:
          this.selected = []
          this.$refs.table.clearSelection()
      }
    },
    upperCase (string) {
      if (string) {
        return string.charAt(0).toUpperCase() + string.substr(1)
      } else {
        return null
      }
    },
    formatMessageTooltip (message) {
      let messageFinal = message
      messageFinal = messageFinal.replace('<br />', '<br/>')
      return messageFinal
    },
    async validerSelection () {
      this.confirmDiffusionList = false
      const tabJson = await this.generateTabJson(1)
      const response = await diffusionAnnonceActivate(tabJson)
      if (response.type == 'error') {
        this.loading = false
        return false
      }
      this.selected = []
      this.programValidLotModal = false
      this.updateSelectedPostCountForUserQuota()
      this.fetchList()
      this.$message({ message: this.$t('portals.broadcast.messageSuccessDiffusion'), type: 'success' })
    },
    async desactiverSelection () {
      this.confirmDesactivationList = false
      const tabJson = await this.generateTabJson(0)
      const response = await diffusionAnnonceActivate(tabJson)
      if (response.type === 'error') {
        this.loading = false
        return false
      }
      this.selected = []
      this.programValidLotModal = false
      this.updateSelectedPostCountForUserQuota()
      this.fetchList()
      this.$message({ message: this.$t('portals.broadcast.messageSuccessDeactivation'), type: 'success' })
    },
    async updateSelectedPostCountForUserQuota () {
      if (this.isSubUser) {
        //   const resultUsersPortailsQuotas = await getUsersPortailsQuotas()
        //   resultUsersPortailsQuotas.forEach(function (diffusion) {
        //     if (diffusion.diffusionId === this.portalId) {
        //       diffusion.usersQuotas.forEach(function (user) {
        //         if (user.userId === this.user.id) {
        //           this.nbAnnoncesSelectionneesUser = user.userPosts
        //         }
        //       })
        //     }
        //   })
        // }
      }
    },
    async generateTabJson (activate) {
      const tabJson = {}
      tabJson.diffusions = []
      if (this.selected.length > 0) {
        for (let i = 0; i < this.selected.length; i++) {
          const tempTab = {}
          tempTab.diffuseur = this.portal.infos._embedded.diffuseur.nom_de_code
          tempTab.annonce = this.selected[i]
          tempTab.activate = activate
          tabJson.diffusions.push(tempTab)
          if ((this.isPromoteur === true || this.isBailleurSocial === true) && this.checkLots === true && this.filter.annonceParente == null) {
            const filterProgramme = {
              annonceParente: this.selected[i],
              limit: 100
            }
            const responseLots = await getPosts(filterProgramme)
            const lots = responseLots.list
            lots.forEach(function (lot) {
              const tempTabLots = {}
              tempTabLots.diffuseur = this.portal.infos._embedded.diffuseur.nom_de_code
              tempTabLots.annonce = lot.id
              tempTabLots.activate = activate
              tabJson.diffusions.push(tempTabLots)
            }, this)
          }
        }
      }
      return JSON.stringify(tabJson)
    },
    toggleSelection () {
      this.results.list.forEach(row => {
        if (this.selected.includes(row.id)) {
          this.$refs.table.toggleRowSelection(row, true)
        }
      })
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    setProgramme (id) {
      this.filter.page = 1
      this.filter.offset = 0
      this.filter.annonceParente = id
      this.fetchList()
    },
    retourProgramme () {
      this.filter.annonceParente = null
      this.fetchList()
    },
    recuperationQuota () {
    }
  },
  beforeMount () {
    this.$store.dispatch('broadcast/loadQuotaPerPortal', { idUser: this.user.id, idPortail: this.$route.params.portal })
  }
}
</script>
